'use client';

import { useEffect } from 'react';

import { useFinance } from '@/hooks/finance/finance.hook';

const DigitalDealer = () => {
  const { selectedFinance } = useFinance();

  useEffect(() => {
    if (process.env.NEXT_PUBLIC_DIGITAL_DEALER_URL) {
      const script = document.createElement('script');

      script.id = 'digital-dealer-script';
      script.type = 'text/javascript';
      script.src = process.env.NEXT_PUBLIC_DIGITAL_DEALER_URL;
      document.head.appendChild(script);

      return () => {
        document.getElementById('digital-dealer-script')?.remove();
      };
    }
  }, []);

  return (
    <digital-dealer
      host-site-id="Kia"
      tenant="KIA"
      redirect-url={
        selectedFinance['redirect-url'] ||
        `${process.env.NEXT_PUBLIC_CLIENT_URL}`
      }
      exit-to-vehicles={
        selectedFinance['exit-to-vehicles'] ||
        `${process.env.NEXT_PUBLIC_CLIENT_URL}/used-cars/search`
      }
      terms-and-conditions-url={`${process.env.NEXT_PUBLIC_CLIENT_URL}/legal/terms-conditions`}
      trusted-and-secure-url={process.env.NEXT_PUBLIC_DIGITAL_DEALER_TRUST_AND_SECURE_URL ?? ''}
      source='KIA.CO.ZA WEBSITE'
      dealer-ref={selectedFinance?.dealerRef}
      dealer-floor={
        selectedFinance?.used ? selectedFinance?.dealerFloor : 'NEWKIA'
      }
      hero-image={selectedFinance?.vehicleImage}
      price={selectedFinance?.price}
      mm-code={selectedFinance?.mmCode}
      used={selectedFinance?.used}
      year={selectedFinance?.year}
      make={selectedFinance?.make}
      model={selectedFinance?.model}
      variant={selectedFinance?.variant}
      mileage={selectedFinance?.mileage}
      region={selectedFinance?.region}
      transmission-type={selectedFinance?.transmission}
    />
  );
};

export default DigitalDealer;
